"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExternalLinks = void 0;

var React = _interopRequireWildcard(require("react"));

var _PrimaryNav = require("./PrimaryNav");

var _core = require("@lingui/core");

var _store = require("../../../redux/store");

var _tenant = require("../../../utils/tenant");

/* eslint-disable no-eq-null */
function getInboundLinks(baseUrl) {
  return {
    deploymentsLink: `${baseUrl}/inbound/deployments`,
    explorerLink: `${baseUrl}/inbound/explorer`,
    meteringLink: `${baseUrl}/inbound/metering`
  };
}

const ExternalLinks = ({
  userAccess
}) => {
  const betaSelections = (0, _store.useAppSelector)(state => state.betaSelections);
  const portfolio = (0, _store.useAppSelector)(state => state.auth.user.portfolio);
  const apertureUrl = (0, _tenant.useApertureUrl)();
  const hasDeploymentsAccess = (userAccess === null || userAccess === void 0 ? void 0 : userAccess.includes('viewDeployments')) === true;
  const hasMeteringAccess = (userAccess === null || userAccess === void 0 ? void 0 : userAccess.includes('viewMetering')) === true; // This hook calculates the deployment and explorer links based on the
  // selected sites and portfolio data. If there is only one project selected,
  // it uses the project's Jira key to construct the links. Otherwise, it
  // returns the default inbound links.

  const {
    deploymentsLink,
    explorerLink,
    meteringLink
  } = React.useMemo(() => {
    var _portfolio$projects, _portfolio$sites;

    const {
      selectedSites
    } = betaSelections;
    const projects = (_portfolio$projects = portfolio === null || portfolio === void 0 ? void 0 : portfolio.projects) !== null && _portfolio$projects !== void 0 ? _portfolio$projects : {};
    const sites = (_portfolio$sites = portfolio === null || portfolio === void 0 ? void 0 : portfolio.sites) !== null && _portfolio$sites !== void 0 ? _portfolio$sites : {};
    const projectIds = selectedSites.reduce((projects, syncoId) => {
      const site = sites[syncoId];
      if (site === undefined) return projects;
      projects.add(site.projectId);
      return projects;
    }, new Set());

    if (projectIds.size === 1) {
      const id = projectIds.values().next().value;
      const jiraKey = projects[id].jira_key;
      if (jiraKey === undefined) return getInboundLinks(apertureUrl);
      return {
        deploymentsLink: `${apertureUrl}/org/${jiraKey}/deployments/sites`,
        explorerLink: `${apertureUrl}/organisations/${jiraKey}`,
        meteringLink: `${apertureUrl}/org/${jiraKey}/metering`
      };
    }

    return getInboundLinks(apertureUrl);
  }, [apertureUrl, betaSelections, portfolio]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasMeteringAccess && /*#__PURE__*/React.createElement(_PrimaryNav.MenuItem, {
    "data-cy": "PrimaryNav-item",
    href: meteringLink,
    target: "_blank",
    rel: "noopener"
  }, _core.i18n._({
    id: 'app_chrome.metering',
    message: `Metering`
  }), /*#__PURE__*/React.createElement(_PrimaryNav.IconExternal, null)), /*#__PURE__*/React.createElement(_PrimaryNav.MenuItem, {
    "data-cy": "PrimaryNav-item",
    href: explorerLink,
    target: "_blank",
    rel: "noopener"
  }, _core.i18n._({
    id: 'app_chrome.histories',
    message: `Histories`
  }), /*#__PURE__*/React.createElement(_PrimaryNav.IconExternal, null)), hasDeploymentsAccess && /*#__PURE__*/React.createElement(_PrimaryNav.MenuItem, {
    "data-cy": "PrimaryNav-item",
    href: deploymentsLink,
    target: "_blank",
    rel: "noopener"
  }, _core.i18n._({
    id: 'app_chrome.deployments',
    message: `Deployments`
  }), /*#__PURE__*/React.createElement(_PrimaryNav.IconExternal, null)));
};

exports.ExternalLinks = ExternalLinks;